import { render } from "./BaseSearchBox.vue?vue&type=template&id=9d9decae&scoped=true&ts=true"
import script from "./BaseSearchBox.vue?vue&type=script&lang=ts"
export * from "./BaseSearchBox.vue?vue&type=script&lang=ts"

import "./BaseSearchBox.vue?vue&type=style&index=0&id=9d9decae&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9decae"]])

export default __exports__